import { css } from "@emotion/react"

import { colorsCP, fontsCP } from "@mkt/cp/src/styles/Tokens"
import { container, getDuration } from "@mkt/cp/src/styles/Functions"
import { above } from "@mkt/cp/src/styles/Breakpoints"
import { animeShow } from "@mkt/ui/styles/Keyframes"

export const wrapper = css`
  background-color: ${colorsCP["neutral-00"]};
`

export const issuers = css`
  ${container};
  padding-top: 32px;
  padding-bottom: 32px;

  ${above["m"]} {
    padding-top: 72px;
    padding-bottom: 72px;
  }
`

export const title = css`
  font-family: ${fontsCP['font-secondary']['font-family']};
  font-weight: 700;
  font-size: 24px;
  line-height: 1.4;
  color: ${colorsCP['neutral-70']};
    text-align: left;
  opacity: 0;
  animation: ${animeShow} ${getDuration(1)} 0.2s ease forwards;

  ${above["m"]} {
    font-size: 28px;
    display: none;
  }
`

export const subtitle = css`
  font-family: ${fontsCP['font-primary']['font-family']};
  font-weight: 400;
  font-size: 16px;
  line-height: 1.5;
  color: ${colorsCP["neutral-50"]};
  padding-top: 16px;
  opacity: 0;
  animation: ${animeShow} ${getDuration(1)} 0.3s ease forwards;

  ${above["m"]} {
    max-width: 360px;
    display: none;
  }
`

export const holder = css`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  margin-top: 24px;

  ${above["m"]} {
    display: none;
  }
`

export const cardHeader = css`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 24px;
`

export const cardIcon = css`
  .icon {
    width: unset;
    height: unset;
  }
`

export const cardTitle = css`
  font-family: ${fontsCP['font-primary']['font-family']};
  font-weight: 700;
  font-size: 16px;
  line-height: 1.5;
  color: ${colorsCP["neutral-70"]};

  ${above["m"]} {
    font-size: 20px;
  }
`

export const group = css`
  display: flex;
  flex-direction: column;
  gap: 24px;
`

export const issuerSlider = (device) => {
  const mobile = css`
    display: flex;

    ${above["m"]} {
      display: none;
    }
  `

  const desktop = css`
    display: none;

    ${above["m"]} {
      display: flex;
    }
  `

  return  css`
    display: flex;
    flex-direction: column;
    gap: 24px;

    ${device === "mobile" && mobile}
    ${device === "desktop" && desktop}
  `
}

export const issuerCard = (isActive) => {
  const active = css`
    background-color: ${colorsCP["blue-10"]};
    border: 1px solid ${colorsCP["blue-30"]};
  `

  return  css`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 75px;
    height: 75px;
    margin: 0 auto;
    background-color: ${colorsCP["neutral-00"]};
    border: 1px solid ${colorsCP["neutral-20"]};
    border-radius: 16px;

    ${isActive && active}

    .icon {
      width: unset;
      height: unset;
    }
  `
}

export const content = css`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

export const issuer = css`
  font-family: ${fontsCP['font-primary']['font-family']};
  font-weight: 700;
  font-size: 18px;
  line-height: 1.5;
  color: ${colorsCP["neutral-70"]};
`

export const text = css`
  font-family: ${fontsCP['font-primary']['font-family']};
  font-weight: 400;
  font-size: 16px;
  line-height: 1.5;
  text-align: left;
  color: ${colorsCP["neutral-50"]};

  a {
    font-weight: 700;
    color: ${colorsCP["blue-40"]};
    text-decoration: none;
  }

  ol, ul {
    padding-top: 24px;
    padding-left: 24px
  }

  ol li {
    list-style: decimal;
  }

  ol li p {
    display: inline;
  }
`
